import React, { useState, memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import OrdersClosed from 'components/trade/OrdersClosed';
import OrdersOpen from 'components/trade/OrdersOpen';
import ControlledTabs from 'components/shared/ControlledTabs';
import Card from 'components/trade/Card';
import { compareComplexProps } from 'helpers/memo';
import { useClosedOrders } from 'helpers/hooks';
import styles from './styles.module.scss';

function TradeOrders(props) {
  const { t } = useTranslation();
  const tabs = [{ label: t('market_open_orders') }, { label: t('market_closed_orders') }];
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const closedOrders = useClosedOrders(props.accountId, props.market.id, activeTabIndex === 1);

  const loading = (activeTabIndex === 1 && closedOrders.loading) || props.market.loading;
  const error =
    (activeTabIndex === 0 && props.openOrders.error) ||
    (activeTabIndex === 1 && closedOrders.error) ||
    props.market.error;

  const refetchOnError = () => {
    if (props.openOrders.error) props.openOrders.refetch();
    if (closedOrders.error) closedOrders.refetch();
    if (props.market.error) props.market.refetch();
  };

  return (
    <Card
      cardStyles={[styles.card]}
      contentWrapperStyles={[styles.cardContents]}
      error={error}
      loading={loading}
      errorRefetch={refetchOnError}
      headerComponent={
        <div className={styles.tabWrap}>
          <ControlledTabs
            tabs={tabs}
            activeTabIndex={activeTabIndex}
            setActiveTabIndex={setActiveTabIndex}
            location={window.location}
            rowStyles={[styles.textTabRow]}
            buttonStyles={[styles.textTabButton]}
            border={false}
            trading
          />
        </div>
      }>
      {activeTabIndex === 0 && (
        <OrdersOpen openOrders={props.openOrders} market={props.market} assets={props.assets} />
      )}
      {activeTabIndex === 1 && (
        <OrdersClosed closedOrders={closedOrders} market={props.market} assets={props.assets} />
      )}
    </Card>
  );
}

TradeOrders.propTypes = {
  accountId: PropTypes.string,
  openOrders: PropTypes.object,
  market: PropTypes.object,
  assets: PropTypes.object
};

TradeOrders.defaultProps = {
  accountId: null,
  openOrders: {},
  market: {},
  assets: {}
};

export default memo(TradeOrders, compareComplexProps);
